import React, {ReactElement, useContext} from 'react';
import Grid, {GridProps} from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import {MobileContext} from '../../containers/MobileProvider';

type PartialGridProps = Partial<GridProps>;

type ProductGridContainerProps = PartialGridProps & {
  justifyContent?: string;
  spacing?: number;
};

type ProductGridItemProps = PartialGridProps & {
  gridKey?: string;
  numColLg?: number;
  numColMd?: number;
  numColSm?: number;
  order?: {[key: string]: number};
};

const Container: React.FC<ProductGridContainerProps> = ({
  children,
  justifyContent,
  spacing
}: ProductGridContainerProps): ReactElement => (
  <Grid
    container
    spacing={spacing}
    className="productGridRow"
    justifyContent={justifyContent}>
    {children}
  </Grid>
);

const Item: React.FC<ProductGridItemProps> = ({
  children,
  gridKey,
  numColLg,
  numColMd,
  numColSm,
  order
}: ProductGridItemProps): ReactElement => {
  const mobile = useContext(MobileContext);
  return mobile ? (
    <Stack key={gridKey}>{children}</Stack>
  ) : (
    <Grid
      item
      className={gridKey ? `${gridKey}-gridCol` : null}
      key={gridKey}
      lg={Math.floor(12 / numColLg)}
      md={Math.floor(12 / numColMd)}
      sm={12 / numColSm}
      xs={12}
      order={order}>
      {children}
    </Grid>
  );
};

Container.defaultProps = {
  justifyContent: undefined,
  spacing: 2
};

Item.defaultProps = {
  numColLg: 1,
  numColMd: 1,
  numColSm: 1,
  gridKey: undefined,
  order: undefined
};

export default {Container, Item};
